import './Reviews.css'
import { Button, Card, Carousel, Flex } from "antd";
import { LeftOutlined, RightOutlined, StarFilled } from '@ant-design/icons'
import { FC, useContext, useEffect, useState } from "react";
import { ReactGoogleReview } from "react-google-reviews";
import { useInterval } from 'usehooks-ts';
import { ResponsiveContext } from '../../context/responsive-context';
const { Meta } = Card

const REVIEWCARD_SHOW_SECONDS = 5
const REVIEW_CHARACTER_COUNT = 280
export const ReviewCard: FC<{reviews: ReactGoogleReview[]}> = ({ reviews }) => {
  const { useVertical } = useContext(ResponsiveContext)
  const [ pauseReviews, setPauseReviews ] = useState(false)
  const [ currentIndex, setCurrentIndex ] = useState(0)
  const [ currentReview, setCurrentReview ] = useState(reviews[0] as ReactGoogleReview)

  const nextReview = () => {
    if (currentIndex + 1 === reviews.length) {
      setCurrentIndex(0)
    }
    else {
      setCurrentIndex((currentIndex) => currentIndex + 1)
    }
    setCurrentReview(reviews[currentIndex])
  }

  const previousReview = () => {
    if (currentIndex === 0) {
      setCurrentIndex(reviews.length - 1)
    }
    else {
      setCurrentIndex(currentIndex - 1)
    }
    setCurrentReview(reviews[currentIndex])
  }

  useInterval(() => {
    nextReview()
  }, pauseReviews ? null : REVIEWCARD_SHOW_SECONDS * 1000)


  return (
    <Carousel
    slidesToShow={useVertical ? 1 : 3}
    pauseOnFocus
    draggable
    infinite
    autoplay={{ dotDuration: true }}
    autoplaySpeed={REVIEWCARD_SHOW_SECONDS * 1000}
    style={ useVertical ? { width: 390 } : { width: 1000 }}>
    {reviews.map(r => {
      return (
        <Card
          title={
            <Flex gap={'small'} align={'center'} justify={'center'}>
            <img height={30} src={r.reviewer.profilePhotoUrl} />
            <div>
            {r.reviewer.displayName}
            </div>
            </Flex>
          }
          className="Reviewcard"
          actions={[
              <div>
              {[...Array(r.starRating)].map(() => <StarFilled style={{ color: "rgb(248, 175, 13)"}} />)}
              </div>
          ]}
        >
        <Meta
        description={
          <Flex align={'center'} justify={'center'} style={{height: '100%'}}>
          <div>
          {`${r.comment.slice(0, REVIEW_CHARACTER_COUNT)}${r.comment.length > REVIEW_CHARACTER_COUNT ? '...' : ''}`}
          </div>
          </Flex>
        }
        />
        </Card>
      )
    })
    }
    </Carousel>
  )
}
